import { useTranslation } from 'react-i18next';

import { isGmcConnectorCode } from '../utils/workspace-connector';

/** Which destination's wording a per-product audit row should read in. */
export type DeliveryDestination = 'meta' | 'gmc';

/** Destination for a row's connector code — GMC codes read as Google, everything else keeps Meta's copy. */
export function destinationOf(connectorCode: string | null | undefined): DeliveryDestination {
  return isGmcConnectorCode(connectorCode) ? 'gmc' : 'meta';
}

/**
 * `t()` for the per-product timeline that names the right destination ("Rejected
 * by Google" vs "Rejected by Meta"). GMC rows read `timelineEntry.gmc.<key>`,
 * falling back to the shared `timelineEntry.<key>` copy for anything GMC doesn't
 * override; Meta rows read the shared copy unchanged.
 */
export function useDestinationCopy(connectorCode: string | null | undefined) {
  const { t } = useTranslation('deliveries');
  const destination = destinationOf(connectorCode);
  return (key: string, options?: Record<string, unknown>): string => {
    const base = t(`timelineEntry.${key}`, options ?? {});
    if (destination !== 'gmc') return base;
    return t(`timelineEntry.gmc.${key}`, { ...(options ?? {}), defaultValue: base });
  };
}
